// extracted by mini-css-extract-plugin
export default {"contactUs":"M5NoRqtHOQuocfpNLEaP","socialItem":"ZRKW0CIFYaJACLzrm8Rh","contactUsTitle":"dX6cyFScnFIBaOgvBaOs","common_bganimation":"vRbXqFBFUbfExbvPkk8e"};